import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Home from '../Home'
import Winners from '../Winners'
import LuckySix from '../LuckySix'
import ResetPassword from '../ResetPassword'

/**
 * Routes
 */

const routes = (
  <Switch>
    <Route path='/home' component={ Home } />
    <Route path='/winners' component={ Winners } />
    <Route path='/lucky6' component={ LuckySix } />
    <Route path='/reset_password' component={ ResetPassword } />

    <Redirect to='/home' />
  </Switch>
)

export default routes



// WEBPACK FOOTER //
// ./src/containers/Root/routes.js